<template>
    <div class="banner-img"
         :style="{height: config.height + 'px', borderRadius: config.borderRadius + 'px', backgroundImage: `url(${config.img})`}"></div>
</template>

<script>
    export default {
        name: "banner",
        props: {
            config: {
                type: Object,
                default() {
                    return {}
                }
            },
        }
    }
</script>

<style scoped lang="less">
    .banner-img {
        background: center no-repeat;
        background-size: cover;
    }
</style>
